
import { message } from "ant-design-vue";
import MediaService from "../api/mediaService";

export const redirectLogin = () => {
	localStorage.clear();
	sessionStorage.clear();
	window.location.href = "/login?t=" + Math.random().toString(36).substr(2);
};

// 将树形数据转化成一维数据
export const treeToList = (treeData, childKey = "children") => {
	let result = [];
	treeData.forEach(item => {
		const children = item[childKey];
		const source = JSON.parse(JSON.stringify(item));
		delete source[childKey];
		result.push(source);
		if (children && children.length) {
			result = [...result, ...treeToList(children, childKey)];
		}
	});

	return result;
};


// 将一维数据转化成树形数据
export const listToTree = (listData, parentId = "1", key = "parentId") => {
	const result = listData.filter(item => item[key] === parentId);
	result.forEach(item => {
		const _children = listData.filter(child => child[key] === item.id);
		if (_children.length) {
			item.children = listToTree(listData, item.id, key);
		}
	});
	return result;
};

export const filterRoutes = (permissions, asyncRoutes = []) => {
	const routes = [];
	const len = asyncRoutes.length;

	for (let i = 0; i < len; i++) {
		const item = asyncRoutes[i];
		// 无有权限判断
		if (!item.meta.code || !item.meta.code.length) {
			routes.push(item);
			continue;
		}

		// 无权限
		if (!item.meta.code.some(code => permissions.includes(code))) continue;


		item.children = filterRoutes(permissions, item.children) || [];

		// 无子集， 本身即为一个可解析路由
		if (!item.isRedirect) {
			routes.push(item);
			continue;
		}

		// if (!item.children.length) {
		// 	item.redirect = { name: "errorPage" };
		// 	routes.push(item);
		// 	continue;
		// }

		item.redirect = { name: item.children[0].name };
		routes.push(item);
	}
	return routes;
};


export const hasRoute = (router, routeName, routeList) => {
	!routeList && (routeList = router.options.routes);

	for (let i = 0; i < routeList.length; i++) {
		if (routeList[i].name === routeName) return true;

		return hasRoute(router, routeName, routeList[i].children || []);
	}

	return false;
};

export const generateRoute = async (store, router, asyncRoutes = [], errorRoutes = []) => {
	let permissionList = [];
	try {
		permissionList = await store.dispatch("getPermissionListService", "aute-dev");
		// eslint-disable-next-line no-console
	} catch (error) { console.log(error); }

	let routes = [...filterRoutes(permissionList.map(item => item.code), asyncRoutes), ...errorRoutes];
	routes = routes.filter(item => !hasRoute(router, item.name));
	router.addRoutes(routes);
	router.options.routes = [...router.options.routes, ...routes];
	store.dispatch("getUserInfoService");
};

export const uploadHandle = async ({ file, klassId, showMessage = true, field="url" }) => {
	return new Promise((resolve, reject) => {
		const params = { file_name: file.name, content_type: file.type };
		if (klassId) {
			params.klass_id = klassId;
		}
		MediaService.createMediaService(params).then(media => {
			var xhr = new XMLHttpRequest();
			xhr.open('PUT', media.upload_url, true);
			xhr.onload = function () {
				MediaService.uploadMediaService({ mediaId: media.id }).then(res => {
					console.time("图片加载时间");
					showMessage && message.success("上传成功，请等待图片加载");
					console.log("============", res[field])
					loadImage(res[field]).then(() => {
						console.timeEnd("图片加载时间");
						resolve(res);
					})
				}).catch((err) => {
					showMessage && message.error("上传异常，请重新操作");
					reject(err);
				})
			};
			xhr.onerror = (err) => {
				showMessage && message.error("上传异常，请重新操作");
				reject(err);
			};
			xhr.send(file); /* file 是要上传的文件对象 */
		}).catch((err) => {
			showMessage && message.error("上传异常，请重新操作");
			reject(err);
		})
	})
}

export const loadImage = (url, times = 1, maxCount = 20) => {
	return new Promise((resolve) => {
		if (times > maxCount) {
			resolve(false);
			return;
		}

		let obj = new Image();
		obj.src = `${url}?t=${new Date().getTime()}`;
		obj.onload = function () {
			return resolve(true);
		}

		obj.onerror = function () {
			setTimeout(() => {
				return new Promise(() => {
					return resolve(loadImage(url, times + 1, maxCount));
				});
			}, 1000)
		}
	});
}


export const getVideoCover = (videoFile) => {
	const video = document.createElement('video') // 也可以自己创建video
	video.src = URL.createObjectURL(videoFile) // url地址 url跟 视频流是一样的
	video.crossOrigin = 'anonymous' // 解决跨域问题，也就是提示污染资源无法转换视频
	video.currentTime = 1 // 第一帧

	video.oncanplay = () => {
		let canvas = document.createElement('canvas') // 获取 canvas 对象
		const ctx = canvas.getContext('2d') // 绘制2d

		canvas.width = video.clientWidth ? video.clientWidth : 320 // 获取视频宽度
		canvas.height = video.clientHeight ? video.clientHeight : 320 //获取视频高度
		// 利用canvas对象方法绘图
		ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
		// 转换成base64形式
		const videoFirstImgsrc = canvas.toDataURL('image/png') // 截取后的视频封面

		video.remove()
		canvas.remove()
		return videoFirstImgsrc
	}
}


// videoFile: 要解析的视频文件资源， time: 获取视频某一时刻的画面
export const captureFrame = (videoFile, time = 0) => {
	return new Promise((resolve) => {
		// 因为dom节点没有渲染到浏览器，视频播放到指定的时间就会停止播放
		const videoElement = document.createElement('video');
		videoElement.currentTime = time; // 设置截取的帧时间
		// 自动播放存在兼容性问题，设置静音解决自动播放在不同浏览器的兼容性问题
		videoElement.muted = true;
		videoElement.autoplay = true;
		videoElement.src = URL.createObjectURL(videoFile);
		videoElement.oncanplay = () => {
			resolve(drawVideoToCanvas(videoElement));
		};
	});
}

const drawVideoToCanvas = (video) => {
	const canvas = document.createElement('canvas');
	const ctx = canvas.getContext('2d');
	canvas.width = video.videoWidth;
	canvas.height = video.videoHeight;
	ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
	return canvas.toDataURL('image/png')
}

export default {};
